import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';

class CountDownTimer extends Component {
  constructor(props) {
    super(props);
    this.startTime = Number(props.duration);
    this.decreaseBy = Number(props.decreaseBy);
    this.timerInterval = '';
    this.state = {
      timeLeft: this.startTime
    }
  }

  componentDidMount() {
    this.startTimer();
  }

  //Method to start timer and update state at regular intervals
  startTimer = () => {
    let that = this;
    this.timerInterval = setInterval(function(){
      let timeLeftValue = that.state.timeLeft;
      timeLeftValue === 0 ? that.stopTimer() : that.setState({ timeLeft: timeLeftValue - that.decreaseBy });
    }, that.decreaseBy * 1000);
  }

  //Method to stop timer
  stopTimer = () => {
    clearInterval(this.timerInterval);
    this.props.changeResendStatus(true);
  }

  render() {
    return (
      <React.Fragment>
        <Icon name="clock outline"/>
        <span className="time">
          { '0:' + ( this.state.timeLeft < 10 ? '0' + this.state.timeLeft : this.state.timeLeft ) }
        </span>
      </React.Fragment>
    );
  }

  componentWillUnmount() {
    clearInterval(this.timerInterval);
  }

  static propTypes = {
    duration: PropTypes.string,
    decreaseBy: PropTypes.string
  }
}

export default CountDownTimer;
